import { Box, List, ListItem, ListItemButton, ListItemText, Stack, Tooltip, Typography } from '@mui/material'
import { t } from 'i18next'
import React from 'react'
import { Ttraining } from '../../shared/types/training.type'
import { formatDate } from '../../shared/utils/DateUtils'
import { Icon } from '@iconify/react'
import { isEmpty } from 'lodash'
import { useAuth } from '../../hooks/useAuth'

function HrHorseExams({ exams, onSelect, selected }: { exams: Ttraining[], onSelect: (exam: Ttraining) => void, selected?: Ttraining }) {
    const {getUserDateFormat} = useAuth()


    if (isEmpty(exams)) return <></>

    return (
        <Stack direction={'column'} spacing={1}>
            <Typography variant='body2'>{t('parameters:selectMaxHeartRateFromPreviousTraining')}</Typography>
            <List dense sx={{ maxHeight: 200, overflowY: 'auto' }} disablePadding>
                {exams.map(exam => (
                    <ListItem disableGutters key={exam.id} >
                        <ListItemButton selected={selected?.id === exam.id} onClick={() => onSelect(exam)}>
                            <ListItemText secondary={<Box display={'flex'} gap={1} alignItems={'center'}>
                                <Tooltip title={t('eap:table:headers:maxHeartRate')} arrow placement='right'>
                                    <Box display={'flex'} gap={0.5} alignItems={'center'}>
                                        <Icon icon='fontisto:pulse' width={14} height={14} />
                                        <Typography variant='caption'>: {exam?.insight?.max_heart_rate ?? '-'} {t('units:bpm')}</Typography>
                                    </Box>
                                </Tooltip>
                                <Typography variant='caption'>|</Typography>
                                <Tooltip title={t('key:maxBest600')} arrow placement='right'>
                                    <Box display={'flex'} gap={0.5} alignItems={'center'}>
                                        <Icon icon='basil:timer-outline' width={14} height={14} />
                                        <Typography variant='caption'>: {exam.insight?.time_best_600} {t("units:seconds")}</Typography>
                                    </Box>
                                </Tooltip>
                            </Box>}>
                                {formatDate(exam.creation_date,getUserDateFormat)}
                            </ListItemText>
                        </ListItemButton>
                    </ListItem>
                ))}

            </List>
        </Stack>
    )
}

export default HrHorseExams